<template>
  <d2-container>
    <div class="resource">
      <div class="resourcebanner"  @click="goToXqing">
        <div class="clickBtn">
            查看详情
        </div>
      </div>
      <div class="resourceBgcolor">
        <div class="resourceSection">
          <h2>算力规格</h2>
          <div class="resourceSectionCont">

            <div v-for="(section, index) in items" :key="index" class="Section1Cont">
              <div class="Section1Tag">
                <img v-if="section.hotSale === 1" :src="tagImageUrl"  alt="热款爆卖标签">
              </div>
              <div class="section1ContTag">
                <h5>{{ section.title }}</h5>
                <span
                  v-if="section.tag === '智算'"
                  class="contTag contTagZhicomputing"
                >
                  {{ section.tag }}
                </span>
                <span
                  v-else-if="section.tag === '超算'"
                  class="contTag contTagChaocomputing"
                >
                  {{ section.tag }}
                </span>
                <span
                  v-else-if="section.tag === '通算'"
                  class="contTag contTagTongcomputing"
                >
                  {{ section.tag }}
                </span>
                <span v-else
                  class="contTag"
                >
                  {{ section.tag }}
                </span>
              </div>

              <div class="section1Contregion">
                <!-- 区域信息 -->
                可用区：{{ section.region }}
              </div>
              <div class="section1ContMsg">
                <div class="title-with-line"><h6>配置</h6></div>
                <div class="section1titmes">
                  <div
                    class="section1lf"
                    v-if="section.configuration.cpu.model"
                  >
                    <div>{{ section.configuration.cpu.model }}</div>
                    <p>CPU</p>
                  </div>

                  <div
                    class="section1rf"
                    v-if="section.configuration.cpu.memory"
                  >
                    <div>{{ section.configuration.cpu.memory }}</div>
                    <p>内存</p>
                  </div>
                </div>
                <div class="section1titmes" v-if="section.configuration.gpu">
                  <div
                    class="section2lf"
                    v-if="section.configuration.gpu.model"
                  >
                    <div>{{ section.configuration.gpu.model }}</div>
                    <p>GPU</p>
                  </div>
                  <div
                    class="section2rf"
                    v-if="section.configuration.gpu.model"
                  >
                    <div>{{ section.configuration.gpu.memory }}</div>
                    <p>显存</p>
                  </div>
                </div>
                <!-- <div class="section1titmes">
                  <div class="section1lf">
                    <div>{{ section.configuration.pcieCommunication }}</div>
                    <p>PCIE通信</p>
                  </div>
                </div> -->
                <div class="title-with-line"><h6>存储</h6></div>
                <div class="storageTxt">{{ section.storage }}</div>
                <div class="title-with-line"><h6>网络</h6></div>
                <div class="networkTxt">
                  <!-- 计算网络 -->
                  <div
                    class="networkTxtlf"
                    v-if="section.network.computeNetwork"
                  >
                    <div>{{ section.network.computeNetwork }}</div>
                    <p>计算网络</p>
                  </div>

                  <!-- 存储网络 -->
                  <div
                    class="networkTxtlf"
                    v-if="section.network.storageNetwork"
                  >
                    <div>{{ section.network.storageNetwork }}</div>
                    <p>存储网络</p>
                  </div>

                  <!-- 业务网络 -->
                  <div
                    class="networkTxtlf"
                    v-if="section.network.businessNetwork"
                  >
                    <div>{{ section.network.businessNetwork }}</div>
                    <p>业务网络</p>
                  </div>
                </div>
                <div class="networkTxt">
                  <div class="networkTxtlf">
                    <div>{{ section.network.internetAccess }}</div>
                    <p>互联网接入</p>
                  </div>
                </div>
              </div>
              <div class="linkBottom">
                <div class="linkBottomlft">
                  <span class="linkBotlft1"> ¥ </span>
                  <el-tooltip class="item" effect="dark" content="更优惠的价格请联系客服" placement="bottom">
                    <span class="linkBotlft2">{{ section.price.split('/')[0] }}</span>
                  </el-tooltip>
                  <span class="linkBotlft3">/{{ section.price.split('/')[1] }}</span>
                </div>
                <button class="linkBottomrt"  @click="redirectToTargetPage(section)">联系客服</button>
              </div>
            </div>
          </div>
        </div>


        <div class="resourceSection2">
          <h2>算力交付</h2>
          <div class="Section2AllCont">
            <div
              v-for="(option, index) in deliveryOptions"
              :key="index"
              :class="['Section2Cont', `Section2Cont${index + 1}`]"
            >
              <div class="Section2ContTitleTxt">
                <h3 class="Section2ContTitle">{{ option.title }}</h3>
                <p class="Section2ContTxt">{{ option.description }} <span>{{ option.descriptionUnit }}</span></p>
              </div>
              <div class="Section2Scenario">
                <span style="font-weight: bold;">适用场景：&nbsp;</span>
                <span>{{ option.scenario }}</span>
              </div>
              <div class="Section2MsgTxt">
                {{ option.details }}
              </div>
              <div class="Section2bottom">
                <button class="Section2link"  @click="redirectToTargetPage">联系客服</button>
              </div>
            </div>
          </div>
        </div>
      


      <div class="resourceSection3"  style="display:none;">
        <h2>典型场景资源推荐</h2>
        <div class="Section3AllCont">
          <div
            v-for="(recommendation, index) in resourceRecommendations"
            :key="index"
            :class="['Section3Cont', `Section3Cont${index + 1}`]"
          >
            <div class="Section3ContTitleTxt">
              <h3 class="Section3ContTitle">{{ recommendation.title }}</h3>
              <p class="Section3ContTxt">{{ recommendation.description }}</p>
            </div>
            <div class="Section3MsgTxt">
              {{ recommendation.details }}
            </div>
            <div class="Section3bottom">
              <button class="Section3link" @click="redirectToTargetPage">联系客服</button>
            </div>
          </div>
        </div>
      </div>

      </div>

      <base-bottom></base-bottom>
    </div>
  </d2-container>
</template>

<script>
import baseBottom from '../components/base-bottom'
import { resList, deliveryModes, resRecommendations } from "@/pages/portal-b-resource/resData";

const bUseStaticData = true
// const bShowRecommendations = true

export default {
  name: 'solutions',
  components: {
    baseBottom
  },
  data() {
    return {
      items:[], //后端请求数据字段
      tagImageUrl: "/image/portalimg/resource/tag.png", // 图片路径
      resourceSections: resList,

      deliveryOptions: deliveryModes,

      resourceRecommendations: resRecommendations,

    };
  },
  mounted() {
    this.getNewsList();
  },
  methods: {
    getNewsList() {
      const params  = {
        type: 1,
        page: 1,
        per_page: 10
      };

      if (!bUseStaticData) {
        this.$axios.get('http://192.168.4.54:8088/power_specifications',{ params })
            .then(res => {
              if (res.code === 200) {
                const resourceSections = res.data.items.map(item => {
                  // 将 item.data 转换为对象
                  const parsedData = JSON.parse(item.data);
                  return {
                    id: item.id, // 添加 id 字段
                    powerType: item.power_type, // 添加 power_type 字段
                    hotSale: parsedData.hotSale, // 添加 热款爆卖 字段
                    title: parsedData.title,
                    tag: parsedData.tag,
                    region: parsedData.region,
                    configuration: {
                      cpu: {
                        model: parsedData.configuration.cpu.model,
                        memory: parsedData.configuration.cpu.memory,
                      },
                      gpu: {
                        model: parsedData.configuration.gpu.model,
                        memory: parsedData.configuration.gpu.memory,
                      },
                      pcieCommunication: parsedData.configuration.pcieCommunication,
                    },
                    storage: parsedData.storage,
                    network: {
                      computeNetwork: parsedData.network.computeNetwork,
                      storageNetwork: parsedData.network.storageNetwork,
                      businessNetwork: parsedData.network.businessNetwork,
                    },
                    price: parsedData.price,
                  };
                });
                // 将处理后的数据赋值给 this.items
                this.items = resourceSections;
                // 打印结果以验证
                //console.log(this.items);
              }else {
                this.$message.error('数据加载失败，请稍后重试！');
              }
            })
            .catch(function (error) {
              console.error('请求失败:', error);
              this.$message.error('数据加载失败，请稍后重试！');
            }).then(() => {
          this.loading = false
        })
      } else {
        this.items = this.resourceSections
      }

    },
    goToXqing() {
      this.$router.push({
        path: '/domesticH200',
      });
    },

    redirectToTargetPage(section) {
      this.$router.push({
        path: '/sptResources',
        query: { power_id: section.id } // 传递当前 section 的 id
      });
    },

   

  }
};
</script>

<style scoped>
@import './index.css';

*, body, html {
  margin: 0;
  padding: 0;
  width: 100%;
  /* background: #f1f1f1; */
}
.lf {
    float: left;
  }
  
  .rf {
    float: right;
  }

</style>
